import React from 'react';

import {AT_RISK_STEP_ID} from './constants';
import {ABitStuckStep} from './steps/a-bit-stuck-step.react-component';
import {ALittleConfusedStep} from './steps/a-little-confused-step.react-component';
import {ConfirmationStep} from './steps/confirmation-step.react-component';
import {InitialStep} from './steps/initial-step.react-component';
import {OverwhelmedStep} from './steps/overwhelmed-step.react-component';
import {SomethingElseStep} from './steps/something-else-step.react-component';
import {TiredStep} from './steps/tired-step.react-component';

import type {AtRiskStepId, StepRendererProps} from './types';

export function renderAtRiskStep(stepId: AtRiskStepId, props: StepRendererProps): React.ReactNode {
    switch (stepId) {
        case AT_RISK_STEP_ID.INITIAL:
            return <InitialStep {...props} />;
        case AT_RISK_STEP_ID.A_BIT_STUCK:
            return <ABitStuckStep {...props} />;
        case AT_RISK_STEP_ID.A_LITTLE_CONFUSED:
            return <ALittleConfusedStep {...props} />;
        case AT_RISK_STEP_ID.TIRED:
            return <TiredStep {...props} />;
        case AT_RISK_STEP_ID.OVERWHELMED:
            return <OverwhelmedStep {...props} />;
        case AT_RISK_STEP_ID.SOMETHING_ELSE:
            return <SomethingElseStep {...props} />;
        case AT_RISK_STEP_ID.CONFIRMATION:
            return <ConfirmationStep {...props} />;
        default:
            return <InitialStep {...props} />;
    }
}
